import { render } from "./LossDashboard.vue?vue&type=template&id=0c0a59f2&scoped=true"
import script from "./LossDashboard.vue?vue&type=script&lang=js"
export * from "./LossDashboard.vue?vue&type=script&lang=js"

import "./LossDashboard.vue?vue&type=style&index=0&id=0c0a59f2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c0a59f2"]])

export default __exports__
import QBtnGroup from 'quasar/src/components/btn-group/QBtnGroup.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtnGroup,QBtn});
